import { styled } from '@mui/material/styles'
import { Box, FormControlLabel } from '@mui/material'
import { Close } from '@mui/icons-material'

export const Wrapper = styled(Box)({
  flex: 1,
  width: 300,
})

export const FormWrapper = styled('div')({
  display: 'flex',
  padding: '20px 0px',
  flexDirection: 'column',
  gap: '20px',
  paddingBottom: '50px',
  width: 'auto',
})

export const InputWrapper = styled('div')({
  width: 'auto',
  marginTop: '5px',
})

export const SectionWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  color: theme.palette.text.primary,
  h4: {
    fontWeight: 400,
    fontSize: '15px',
  },
}))

export const BtnSectionWrapper = styled(SectionWrapper)(({ theme }) => ({
  width: '300px',
  position: 'fixed',
  bottom: 0,
  display: 'flex',
  flexDirection: 'row',
  gap: '10px',
  backgroundColor: theme.palette.common.white,
  padding: '10px 0px',
}))

export const BtnWrap = styled('div')({
  marginLeft: 'auto',
})

export const Label = styled('label')(({ theme }) => ({
  color: theme.palette.grey[500],
  fontSize: '13px',
}))

export const CloseIcon = styled(Close)(({ theme }) => ({
  color: theme.palette.text.secondary,
}))

export const BtnWrapper = styled('div')(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  height: 'auto',
  padding: '10px 0px',
  width: '23%',
  backgroundColor: theme.palette.common.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
}))

export const CheckBox = styled(FormControlLabel)(({ theme }) => ({
  '.MuiSwitch-root': {
    '.MuiSwitch-switchBase': {
      '&:hover': {
        backgroundColor: theme.palette.primary.light, //'#23619230'
      },
      '&.Mui-checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: theme.palette.primary.dark, //'#9ebcff33'
        },
      },
      '&.Mui-checked+.MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main,
      },
      '&.Mui-checked+.MuiSwitch-switchBase': {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  '.MuiTypography-root': {
    color: 'black',
    fontSize: '14px',
  },
}))
